<template>
     <div>
    <v-divider></v-divider>
         <v-toolbar flat color="white">
             <h2 class="heading dark-grey--text px-4 py-2">Transactions: {{locationNetworkSummaryPage.name}}</h2>
         </v-toolbar>
         <v-divider></v-divider>
    <v-toolbar flat color="white">
      <v-flex xs12 sm12 md12>
        <v-card flat color="white">
          <h3>Commission: <span class="green--text">{{salesValue|currency}}</span></h3>
        </v-card>
      </v-flex>
    </v-toolbar>
    <v-divider></v-divider>
    <v-toolbar flat color="white">
        <v-flex xs4>
      <v-menu>
        <v-text-field
          :value="this.setStart"
          slot="activator"
          label="From Date"
          prepend-icon="date_range"
        ></v-text-field>
        <v-date-picker v-model="setStart"></v-date-picker>
      </v-menu>
        </v-flex>
        <v-flex xs4>
      <v-menu>
        <v-text-field
          :value="this.setEnd"
          slot="activator"
          label="To Date"
          prepend-icon="date_range"
        ></v-text-field>
        <v-date-picker v-model="setEnd"></v-date-picker>
      </v-menu>
        </v-flex>
        <v-spacer></v-spacer>
      <v-btn round color="red white--text" @click="setStart=null;setEnd=null">CLEAR DATES</v-btn>
      <v-btn round color="primary" @click="filterTransactions=true">Apply Filter</v-btn>
    </v-toolbar>
    <v-divider></v-divider>

    <v-toolbar flat color="white">
      <v-btn round color="primary"><v-icon>get_app</v-icon> 
      <download-excel
    :data="networkTransactions"
    :fields="transactionExportFields"
    :name="'Transactions_'+new Date().getTime()+'.xls'">
    Export Transactions to Excel
</download-excel></v-btn>
      
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
    :loading="isLoading"
      disable-initial-sort
      :headers="transactionHeaders"
      :items="networkTransactions"
      item-key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
    >
      <template v-slot:items="props">
       <td class="text-xs-center">{{formatDate(props.item.date)}}</td>
        <td class="text-xs-center">{{props.item.locationNode.name}}</td>
        <td class="text-xs-center" v-if="props.item.locationNetwork !== null">{{props.item.locationNetwork.name}}</td>
        <td v-else></td>
        <td class="text-xs-center" v-if="props.item.location !== null">{{props.item.location.locationDescription}}</td>
        <td v-else></td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.amount|currency}}</td>
      </template>
    </v-data-table>
    </div>
</template>
<script>
import Api from "@/services/Api";
import { mapState } from "vuex";
import dateformat from "dateformat";
export default {
    data(){
        return {
       transactionHeaders: [
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        {
          text: "Location Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Location Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Unit",
          align: "center",
          value: "location.locationdescription"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Amount",
          align: "center",
          value: "Amount"
        }
      ],
      setStart: null,
      setEnd: null,
      initialTransactions: [],
      filterTransactions: false,
      filterDescription: null,
      filterTransactionType: null,
      totals: [],
      transactionSearch: false,
      filterFrequency: null,
      frequencyList: ["Recurring", "Once-Off"],
      descriptionList: this.descriptionlist,
      transactionExportFields: {
        'transactionDate': 'date',
        'node': 'locationNode.name',
        'network': 'locationNetwork.name',
        'unit': 'location.locationDescription',
        'initialActivation': 'serviceAccount.initialActivation',
        'packageSpeed': 'serviceAccount.packagesIsp.packagesFno.speedProfile.name',
        'commission': 'amount'
        },
      Partners: [{ id: 1, name: "Fibre Geeks" }],
      Isps: [],
      descriptionList: [],
      isLoading:true,
      showDetails: true,
      networkTransactions: [],
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      pagination: {},
      locationNetworkSummaryPage: [],
      salesValue: 0,
        }
    },
    created(){
        this.initialize();
    },
    watch: {
    dialog(val) {
      val || this.close();
      
    },
  async filterTransactions(value) {
      this.networkTransactions=this.initialTransactions
      if(this.setStart){
        let startDate = this.setStart
        this.networkTransactions= await this.networkTransactions.filter(function(el){
          return el.date>=startDate
      })
      }
      if(this.setEnd){
        let endDate = this.setEnd
        this.networkTransactions= await this.networkTransactions.filter(function(el){
          return el.date<=endDate
      })
      }
      if(this.filterDescription){
        let description = this.filterDescription
        this.networkTransactions= await this.networkTransactions.filter(function(el){
          return el.description===description
      })}
      if(this.filterFrequency){
        let frequency = null
        if(this.filterFrequency==='Recurring'){
          frequency = true
        } else if(this.filterFrequency==='Once-Off'){
          frequency = false
        }
        if(frequency !==null){
          this.networkTransactions= await this.networkTransactions.filter(function(el){
          return el.isRecurring===frequency
      })
        }
      }
       this.sum();
      this.filterTransactions = false;
    }
   
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user"])    
  },
  methods:{
      formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
      logout() {
      this.drawer = false;
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setPermission", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.state.isUserLoggedIn = false;
      this.$router.push("/login");
    },
  async getTransactions() {
      this.isLoading=true
      this.descriptionList = [];
      await Api()
        .get("/transactions/byCustomer/asSupplier/endLocationsByNetwork/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.initialTransactions = response.data
          this.networkTransactions = response.data;
          for (let i = 0; i < this.networkTransactions.length; i++) {
            if (
              !this.descriptionList.includes(
                this.networkTransactions[i].description
              )
            ) {
              this.descriptionList.push(
                this.networkTransactions[i].description
              );
            }
          }
          this.sum();
          this.isLoading=false
        });
    },
    sum() {
      this.salesValue = 0;      
      for (let i = 0; i < this.networkTransactions.length; i++) {        
          this.salesValue += this.networkTransactions[i].amount;       
      }
    },
    initialize() {
      this.getTransactions();
      this.fetchLocationNetworkSummaryPage();
    },
    fetchLocationNetworkSummaryPage() {
      Api()
        .get("/locationNetworks/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.locationNetworkSummaryPage = response.data;
        });
    },
  }
}
</script>

